module.exports = __webpack_public_path__ + "static/media/validate.9e2d0849.svg";